import React, { useState } from 'react';
import BookingModal from './BookingModal';

// Updated Footer component with enhanced navigation and contact information
// Last updated: May 2024
// Updated by kouvi10@gmail.com
const Footer = () => {
  const [showModal, setShowModal] = useState(false);

  const handleEmailClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.href = "mailto:contact@tilimousine.com";
  };

  const handlePhoneClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.href = "tel:+18573123332";
  };

  const handleWhatsAppClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const choice = window.confirm('Would you like to:\n\nClick OK for WhatsApp\nClick Cancel for SMS');
    if (choice) {
      window.open('https://wa.me/18573123332', '_blank');
    } else {
      window.location.href = 'sms:+18573123332';
    }
  };

  return (
    <footer className="bg-black text-white py-16">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center mb-12">
          <button
            onClick={() => setShowModal(true)}
            className="btn-primary bg-gold hover:bg-gold/90 text-black font-cinzel font-bold px-8 py-3 rounded-full transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-gold/20"
            aria-label="Book your luxury ride now"
          >
            Book Your Ride
          </button>
        </div>

        <div className="flex flex-col md:flex-row justify-between pb-12 border-b border-gold/10">
          <div className="mb-8 md:mb-0">
            <div className="flex items-center space-x-2 mb-4">
              <div className="h-8 w-8 rounded-full border-2 border-gold flex items-center justify-center">
                <span className="font-cinzel text-gold text-sm font-bold">T</span>
              </div>
              <span className="font-cinzel text-white text-xl">TiLimousine</span>
            </div>
            <p className="text-white/60 max-w-xs mb-4">
              Luxury chauffeur service providing premium transportation for discerning clients.
            </p>
            <p className="text-gold font-cinzel text-sm">
              Where Your Journey Begins
            </p>
          </div>
          
          <div className="flex flex-col md:flex-row gap-12">
            <div>
              <h4 className="font-cinzel text-gold text-lg mb-4">Company</h4>
              <ul className="space-y-2">
                <li><a href="#about" className="text-white/60 hover:text-gold">About Us</a></li>
                <li><a href="#fleet" className="text-white/60 hover:text-gold">Our Fleet</a></li>
                <li><a href="#services" className="text-white/60 hover:text-gold">Services</a></li>
                <li><a href="#reviews" className="text-white/60 hover:text-gold">Reviews</a></li>
                <li><a href="#contact" className="text-white/60 hover:text-gold">Contact</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-cinzel text-gold text-lg mb-4">Services</h4>
              <ul className="space-y-2">
                <li><a href="#services" className="text-white/60 hover:text-gold">Executive Airport Transfer</a></li>
                <li><a href="#services" className="text-white/60 hover:text-gold">Hourly/As Direct</a></li>
                <li><a href="#services" className="text-white/60 hover:text-gold">Corporate & Leisure</a></li>
                <li><a href="#services" className="text-white/60 hover:text-gold">Sporting Event Transfers</a></li>
                <li><a href="#services" className="text-white/60 hover:text-gold">Wedding & Special Events</a></li>
                <li><a href="#services" className="text-white/60 hover:text-gold">Medical Transportation</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8 pt-12">
          <div className="flex space-x-4">
            <a 
              href="tel:+18573123332"
              className="text-white/60 hover:text-gold group"
              aria-label="Call us at +1 (857) 312-3332"
            >
              <div className="rounded-full h-10 w-10 flex items-center justify-center bg-gold/10 group-hover:bg-gold/20 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
            </a>
            <a 
              href="mailto:contact@tilimousine.com"
              className="text-white/60 hover:text-gold group"
              aria-label="Email us at contact@tilimousine.com"
            >
              <div className="rounded-full h-10 w-10 flex items-center justify-center bg-gold/10 group-hover:bg-gold/20 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
            </a>
            <a 
              href="sms:+18573123332"
              className="text-white/60 hover:text-gold group"
              aria-label="Send us an SMS"
            >
              <div className="rounded-full h-10 w-10 flex items-center justify-center bg-gold/10 group-hover:bg-gold/20 transition-colors">
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="h-5 w-5 text-gold" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
              </div>
            </a>
            <a 
              href="https://wa.me/18573123332"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-gold group"
              aria-label="Contact us on WhatsApp"
            >
              <div className="rounded-full h-10 w-10 flex items-center justify-center bg-gold/10 group-hover:bg-gold/20 transition-colors">
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="h-5 w-5 text-gold" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
                  <path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1zm0 0a5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1"/>
                </svg>
              </div>
            </a>
            <a 
              href="https://www.instagram.com/tilimousine?igsh=ejNrempiZm5raDdm"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-gold group"
              aria-label="Follow us on Instagram"
            >
              <div className="rounded-full h-10 w-10 flex items-center justify-center bg-gold/10 group-hover:bg-gold/20 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                </svg>
              </div>
            </a>
            <a 
              href="https://www.facebook.com/share/16QvJTW2BH/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-gold group"
              aria-label="Follow us on Facebook"
            >
              <div className="rounded-full h-10 w-10 flex items-center justify-center bg-gold/10 group-hover:bg-gold/20 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </div>
            </a>
          </div>
        </div>
        
        <BookingModal open={showModal} onClose={() => setShowModal(false)} />
        
        <div className="flex flex-col md:flex-row justify-between items-center mt-12 pt-8 border-t border-gold/10">
          <p className="text-white/40 text-sm mb-4 md:mb-0">
            &copy; 2025 TiLimousine. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-white/40 hover:text-gold text-sm">Privacy Policy</a>
            <a href="#" className="text-white/40 hover:text-gold text-sm">Terms of Service</a>
            <a href="#" className="text-white/40 hover:text-gold text-sm">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
